module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre2"
  }, [_c('br', {
    staticClass: "calibre10",
    attrs: {
      "id": "calibre_pb_1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478517"
    }
  }, [_c('span', {
    staticClass: "calibre12"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre12"
  }, [_vm._v("The Blue Rose")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("…signifying hope against unattainable love…longing to attain the impossible.")]), _c('span', {
    staticClass: "calibre13"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("—A Chinese Folktale")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“The General who advances without coveting fame and retreats without fearing disgrace, whose only thought is to protect his country and do good service for his sovereign, is the…")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Jewel of the Kingdom")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(".” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("—Sun Tzu ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cbf8e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_001.vue
// module id = 63
// module chunks = 0